import React from 'react';

import { Container, NumeratorBadge, DenominatorBadge } from './styles';

interface Props {
  numerator?: number;
  denominator: number;
}

const RatioBadge: React.FC<Props> = ({ numerator, denominator }) => {
  return (
    <Container>
      {numerator !== undefined && (
        <>
          <NumeratorBadge>{numerator}</NumeratorBadge>
          <span>/</span>
        </>
      )}

      <DenominatorBadge>{denominator}</DenominatorBadge>
    </Container>
  );
};

export default RatioBadge;
